import React, { useEffect, useState } from "react";
import "./Orders.css";
import axiosConfig from "../Service/axiosConfig";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import Masters from "../Components/masters.json";
import { FormParser, PopupModal } from "../Components";
const ShippingInstructions = ({
  show,
  setShow,
  orderId,
  setLoadingButton,
  setActive,
  CountDisplay,
  OderSCount,
}) => {
  const [step, setStep] = useState(1);
  const [shippingshow, setShippingShow] = useState(true);
  const [smshow, setSmshow] = useState(false);
  const [Assign, setAssign] = useState(false);
  const [other, setOther] = useState(false);
  const [ShippingMethod, setShippingMethod] = useState([]);
  const [DeliveryAgents, setDeliveryAgents] = useState([]);
  const [Deliveradd, setDeliverAdd] = useState(false);
  const [Data, setData] = useState({});
  const [orderImage, setorderImage] = useState(false);
  const [AddPhoto, setAddPhoto] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [popupType, setpopupType] = useState("");
  const [message, setMessage] = useState("");
  const [newDeliveryAgentId, setNewDeliveryAgentId]= useState(null)
  const MastersModal = Masters.DeliveryAgents;
  const handleFileChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    const name = "order_item_photo";
    console.log(file);
    setImageFile(file);
    setData({ ...Data, [name]: file });
  };
  // const HandleFiles = (e) => {
  //     e.preventDefault();
  //     const file = e.target.files[0];
  //     const name = e.target.name;
  //     const value = file;
  //     SetData({ ...Data, [name]: value });
  // };
  const HandleChange = (name, event) => {
    console.log(name, event);
    setData({ ...Data, [name]: event });
  };
  const HandleselectChange = (selectedOption, name) => {
    setData({
      ...Data,
      [name]: selectedOption?.value ? selectedOption?.value : "",
    });
  };
  const handleShipRocket = async (id) => {
    try {
      let data = ShippingMethod.filter((data) => data.id === id);
      if (data.length === 0) return;
      await axiosConfig.post(
        `/accounts/order-shipments/${orderId}/order_shipment/`,
        {
          delivery_type: "Ship Rocket",
          email: data[0].email,
          password: data[0].password,
        }
      );
      setShow(false);
    } catch (error) {
      console.log(error);
    }
  };
  const handleShipping = (method, id, orderStatus) => {
    console.log(method, id, "mmm");
    setShippingShow(false);
    if (method === "Self Shipping") {
      setSmshow(true);
      setOther(false);
      HandleChange("shipping_method", id);
      setStep(2)
    }
    else if (method === "Other") {
      setSmshow(false);
      setOther(true);
      HandleChange("shipping_method", id);
      setStep(6)
    }
    else if (method === "Ship Rocket") {
      handleShipRocket(id);
    }
    // const postData = {
    //   shipping_method: method,
    //   orderstatus: "Shipped",
    // };
    // try {
    //   axiosConfig.post(
    //     `/accounts/orders/${orderId}/order_status_update/`,
    //     postData
    //   );
    // } catch (error) {
    //   console.log(error);
    // }
  };
  const handleAssign = (Assign) => {
    console.log(Assign);
    if (Assign === "Auto") {
      setSmshow(false);
      HandleChange("delivery_type", Assign);
      setorderImage(true);
      // handleUpdated()
      setStep(4)
    }
    if (Assign === "Manual") {
      setSmshow(false);
      setAssign(true);
      HandleChange("delivery_type", Assign);
      GetDeliveryAgents();
      setStep(3)
    }
  };

  const handleDeliveryAgent = (event) => {
    setStep(4)
    event.preventDefault();
    setAssign(false);
    setorderImage(true);
  };
  const HandleTracking = (e) => {
    e.preventDefault();
    setOther(false);
    setorderImage(true);
    // setStep()
  };
  const handleopenImage = () => {
    setorderImage(true);
    setAddPhoto(true);
    document.getElementById("fileInput").click();
  };
  // const handleSkip = () => {
  //   console.log("skip");
  //   handleUpdated();
  // };
  // const handleUpdated = async () => {
  //   console.log("shipId", Data);
  //   console.log(orderId, "orderid");
  //   let Data_to_send = {
  //     orderstatus: "Accepted",
  //     shipping_method: Data.shipping_method,
  //   };
  //   let Data_to_post = {
  //     delivery_type: Data.delivery_type,
  //     delivery_agent: Data.delivery_agent,
  //     order_item_photo: Data.order_item_photo,
  //     tracking_url: Data.tracking_url,
  //   };
  //   console.log(Data_to_send, "Data_to_send", Data_to_post);
  //   try {
  //     const response = await axiosConfig.post(
  //       `/accounts/orders/${orderId}/order_status_update/`,
  //       Data_to_send,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     console.log(response, "response");
  //     const responce = await axiosConfig.post(
  //       `/accounts/order-shipments/${orderId}/order_shipment/`,
  //       Data_to_post,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     setShow(false);
  //     console.log(responce, "response");
  //     setLoadingButton(false);
  //     setActive("Accepted");
  //     CountDisplay();
  //     OderSCount(["Placed", "Accepted"]);
  //     setMessage("Order and Order Status updated Successfully!");
  //   } catch (error) {
  //     console.log(error);
  //     setShow(false);
  //   }
  // };
  const GetDeliveryAgents = async () => {
    try {
      let resp = await axiosConfig.get(
        `/deliveryagent/delivery-agents/?page_size=500&is_suspended=false&fields_user=id,full_name,mobileno,email,role,last_login`
      );
      console.log(resp.data.results);
      setDeliveryAgents(resp.data.results);
    } catch (error) {
      console.log(error);
    }
  };
  const GetShippingMetthods = async () => {
    try {
      let resp = await axiosConfig.get(
        `/accounts/shipping-methods/?page_size=500&is_suspended=false`
      );
      console.log(resp.data.results);
      setShippingMethod(resp.data.results);
    } catch (error) {
      console.log(error);
    }
  };
 const formSubmit = async (FormData) => {
    try {
      const res = await axiosConfig.post("/deliveryagent/delivery-agents/", FormData);
      const newAgentId = res.data.id;
      
      // Store the new delivery agent ID
      setNewDeliveryAgentId(newAgentId);
      
      // Update the form data with the new agent ID
      setData({ ...Data, delivery_agent: newAgentId });
      
      setMessage("Delivery agent Added Successfully!");
      setpopupType("success");
      setDeliverAdd(false);
      
      // Return to step 3 and refresh the delivery agents list
      setStep(3);
      GetDeliveryAgents(); // Refresh the list to include the new agent
      
    } catch (error) {
      console.log(error);
      setpopupType("error");
      setMessage("Error adding delivery agent");
    }
  };
  const handleUpdated = async () => {
    console.log("shipId", Data);
    console.log(orderId, "orderid");

    try {
      // First update the order status to Accepted with delivery agent
      const response = await axiosConfig.post(
        `/accounts/orders/${orderId}/order_status_update/`,
        {
          orderstatus: "Accepted",
          delivery_agent: Data.delivery_agent,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response, "response");

      // Then add shipment details if needed
      if (Data.tracking_url || Data.order_item_photo) {
        const responce = await axiosConfig.post(
          `/accounts/order-shipments/${orderId}/order_shipment/`,
          {
            delivery_type: Data.delivery_type,
            delivery_agent: Data.delivery_agent,
            order_item_photo: Data.order_item_photo,
            tracking_url: Data.tracking_url,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(responce, "response");
      }

      setShow(false);
      setLoadingButton(false);
      setActive("Accepted");
      CountDisplay();
      OderSCount(["Placed", "Accepted"]);
      setMessage("Order accepted successfully!");
    } catch (error) {
      console.log(error);
      setShow(false);
      setMessage("Error accepting order");
    }
  };
  useEffect(() => {
    if (show === true) {
      setStep(1)
      setData({});
      GetDeliveryAgents();
      setShippingShow(false);
      GetShippingMetthods()
      setSmshow(true);
    }
    console.log(show);
  }, [show]);
  return (
    <>
      {step == 1 && (
        <div>
          <h4 style={{ textAlign: "center", paddingBottom: "16px" }}>
          </h4>
          <div className="ship-cont">
            {ShippingMethod.map((Data, index) => {
              return (
                <div
                  className="shipping-types"
                  key={index}
                  onClick={() =>
                    handleShipping(
                      Data.shipping_method_name,
                      Data.id,
                      Data.orderstatus
                    )
                  }
                >
                  {console.log(Data, "Data method")}
                  {Data.name}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {step === 2 && (
        <div>
          <h4 style={{ textAlign: "center", paddingBottom: "16px" }}>
            Select Self Shipping
          </h4>
          <div className="ship-cont">
            <div
              className="shipping-types"
              onClick={() => handleAssign("Auto")}
            >
              Auto Assign
            </div>
            <div
              className="shipping-types"
              onClick={() => handleAssign("Manual")}
            >
              Manual Assign
            </div>
          </div>
        </div>
      )}
      {step === 3 && (
        <div>
          <div
            style={{
              textDecoration: "underline",
              textAlign: "right",
              marginBottom: "16px",
              color: "#1b7d78",
            }}
            onClick={() => {
              setDeliverAdd(true);
              setAssign(false);
              setStep(5)
            }}
          >
            +Add New
          </div>
          <form
            onSubmit={(e) => {
              handleDeliveryAgent(e);
            }}
          >
            <Select
              options={DeliveryAgents.map((res) => ({
                value: res.id,
                label: res.user?.full_name,
              }))}
              placeholder="Select Delivery-Agent"
              value={DeliveryAgents.map((res) => ({
                value: res.id,
                label: res.user?.full_name,
              })).find((res) => res.value === Data.delivery_agent)}
              onChange={(selectedOption) =>
                HandleselectChange(selectedOption, "delivery_agent")
              }
              required
            />
            <button
              type="submit"
              className="btn btn-primary btn-block"
              style={{ marginTop: "16px" }}
            >
              Assign
            </button>
          </form>
        </div>
      )}
      {step === 6 && (
        <div>
          <form onSubmit={HandleTracking}>
            <div className="form-group">
              <label htmlFor="validationCustom01">Tracking URL : </label>
              <div className="nuput-box">
                <input
                  type="url"
                  className="form-control"
                  id="validationCustom01"
                  placeholder="Paste/ Tracking Url"
                  name="tracking_url"
                  value={Data.tracking_url}
                  onChange={(event) =>
                    HandleChange("tracking_url", event.target.value)
                  }
                />
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-block" onClick={()=>setStep(1)}>
              Submit
            </button>
          </form>
        </div>
      )}
      {/* {orderImage && (
        <div>
          <h4 style={{ textAlign: "center", paddingBottom: "16px" }}>
            Add orders photos to improve quality
          </h4>
          <button
            className="btn btn-primary btn-block"
            style={{ marginBottom: "16px", padding: "7px" }}
            onClick={handleopenImage}
          >
            {" "}
            <input
              type="file"
              id="fileInput"
              style={{ display: "none" }}
              onChange={handleFileChange}
              accept="image/*"
            />
            Add Items Photo
          </button>
          {imageFile && (
            <div>
              <h4>Selected Image Preview:</h4>
              <img
                src={URL.createObjectURL(imageFile)}
                alt="Selected"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  marginBottom: "10px",
                }}
              />
              <button
                type="submit"
                className="btn btn-primary"
                onClick={() => {
                  handleUpdated();
                }}
              >
                Submit
              </button>
            </div>
          )}
          <div
            style={{
              textDecoration: "underline",
              textAlign: "right",
              paddingBottom: "16px",
              color: "#1b7d78",
            }}
            onClick={() => handleSkip()}
          >
            Skip
          </div>
        </div>
      )} */}
      {step === 4 && (
        <div>
          <h4 style={{ textAlign: "center", paddingBottom: "16px" }}>
            Delivery agent assigned successfully
          </h4>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              style={{
                padding: "8px 0px",
                background: "#1b7d78",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                width: "18%",
              }}
              onClick={() => handleUpdated()}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {step === 5 && (
        <>
          <h4 style={{ textAlign: "center", paddingBottom: "16px" }}>
            Add DeliveryAgent
          </h4>
          <FormParser
            modelObject={MastersModal}
            formSubmit={formSubmit}
            error={Error}
            buttonTitle="Save"
          />
        </>
      )}
      {popupType !== "" && (
        <PopupModal
          setpopupType={setpopupType}
          popupType={popupType}
          Navigation=""
          Message={message}
          setMessage={setMessage}
        // error={Error}
        />
      )}
    </>
  );
};
export { ShippingInstructions };
